import React from 'react';

export default function Range({ from, to }) {
    return (
        <span>
            { from } { to && '-' } { to }
        </span>
    );
}
